<template>
  <div id="tagList" class="page-notbreadcrumb">
    <section class="page-list">
      <div class="title">
        <div class="title_l">
          <span class="tit">标签</span>
        </div>
        <div class="title_r">
          <el-popover
            popper-class="menu-popper"
            placement="bottom"
            width="170"
            height="105"
            trigger="hover"
            :visible-arrow="false"
            v-model="visible"
          >
            <div class="node-act">
              <div @click=";(isAddFolder = true), editFolderName({})">
                <i class="iconfont iconwenjianjia1" />
                <span>创建文件夹</span>
              </div>
              <div @click=";(isAdd = true), (visible = false), editData({})">
                <i class="iconfont iconbiaoqian" />
                <span>创建标签</span>
              </div>
            </div>
            <i
              slot="reference"
              class="el-icon-circle-plus-outline add-icon"
            ></i>
          </el-popover>
        </div>
      </div>
      <div class="list_box">
        <div class="list_search">
          <el-input
            v-model="name"
            placeholder="请输入文件夹/标签名称"
            clearable
            @input="getTreeData('')"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="getTreeData('')"
            />
          </el-input>
        </div>
        <div v-show="condition.yearType == 1" class="time-select">
          <span class="label">年份：</span>
          <el-select
            v-model="condition.dataYear"
            placeholder="请选择年份"
            @change="
              treeData = []
              getTreeData(2, 1)
            "
          >
            <el-option
              v-for="(item, index) in yearOption"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="list_main">
          <el-tree
            :data="treeData"
            :props="defaultProps"
            accordion
            :highlight-current="true"
            :default-expand-all="true"
            @node-click="getLabelEnt"
            class="tag-tree"
          >
            <div
              class="node-item"
              slot-scope="{ node, data }"
              style="width: 85%; overflow: hidden"
            >
              <div class="subtitle" style="float: left">
                <i
                  v-if="data.isDirector == 1"
                  class="el-icon-folder-opened"
                ></i>
                <i v-else class="el-icon-price-tag"></i>
                <span class="overFlowHid1" :title="node.label">{{
                  data.isDirector == 2
                    ? (data.dataYear ? data.dataYear + '-' : '') + node.label
                    : node.label
                }}</span>
              </div>
              <div class="more" style="float: right">
                <el-popover
                  placement="bottom"
                  width="153"
                  height="105"
                  trigger="hover"
                  popper-class="menu-popper"
                  :visible-arrow="false"
                  v-model="data.visible"
                >
                  <!-- 二级文件夹 -->
                  <div
                    v-if="data.isDirector == 1 && data.parentId"
                    class="node-act"
                  >
                    <div
                      class="more-item"
                      @click="
                        ;(data.visible = false), (isAdd = true), editData(data)
                      "
                    >
                      创建子标签
                    </div>
                    <div
                      class="more-item"
                      @click="
                        ;(data.visible = false),
                          (isAddFolder = false),
                          editFolderName(data)
                      "
                    >
                      编辑
                    </div>
                    <div
                      class="more-item"
                      @click=";(data.visible = false), delFolder(data)"
                    >
                      删除
                    </div>
                  </div>
                  <!-- 一级文件夹 -->
                  <div
                    v-if="data.isDirector == 1 && !data.parentId"
                    class="node-act"
                  >
                    <div
                      class="more-item"
                      @click="
                        ;(data.visible = false),
                          (isAddFolder = true),
                          editFolderName(data)
                      "
                    >
                      创建子文件夹
                    </div>
                    <div
                      class="more-item"
                      @click="
                        ;(data.visible = false), (isAdd = true), editData(data)
                      "
                    >
                      创建子标签
                    </div>
                    <div
                      class="more-item"
                      @click="
                        ;(data.visible = false),
                          (isAddFolder = false),
                          editFolderName(data)
                      "
                    >
                      编辑
                    </div>
                    <div
                      class="more-item"
                      @click=";(data.visible = false), delFolder(data)"
                    >
                      删除
                    </div>
                  </div>
                  <!-- 标签 -->
                  <div v-if="data.isDirector != 1" class="node-act">
                    <div
                      class="more-item"
                      @click="
                        ;(data.visible = false), (isAdd = false), editData(data)
                      "
                    >
                      编辑
                    </div>
                    <div
                      class="more-item"
                      @click=";(data.visible = false), moveLabel(data)"
                    >
                      移动至
                    </div>
                    <div
                      class="more-item"
                      @click=";(data.visible = false), delLabel(data)"
                    >
                      删除
                    </div>
                  </div>
                  <i
                    slot="reference"
                    class="iconfont iconduogongneng"
                    @click.stop
                  />
                </el-popover>
              </div>
            </div>
          </el-tree>
        </div>
      </div>
    </section>
    <section class="page-prop">
      <section class="page-header">
        <span>标签名单</span>
        <!-- <div class="btn-save" @click="$router.push({name:'entImportList'})">
                    <i class="el-icon-pie-chart" />
                    <span>导入历史</span>
                </div> -->
        <div>
          <el-button @click="downLoadModel">模板下载</el-button>
          <el-button
            @click="
              $router.push({
                name: 'batchAdd',
                query: { name: activeItem.name, id: activeItem.id, type: 2 },
              })
            "
            >批量添加</el-button
          >
          <el-button @click="preciseAddVisible = true">精准添加</el-button>
          <el-button @click="downLoad" type="primary">数据导出</el-button>
        </div>
      </section>
      <div class="detail">
        <div class="condition_box">
          <div class="condition_item">
            <el-input
              v-model="condition.entName"
              placeholder="请输入企业名称"
              clearable
              @input="getEntData(1)"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="getEntData(1)"
              />
            </el-input>
          </div>
          <div class="condition_item">
            <el-button @click="clearAllEnt" type="danger">清空</el-button>
          </div>
        </div>
        <div class="label-banner" v-if="activeItem.id">
          <div class="label">
            {{ activeItem.name || '-' }}
            <span v-if="activeItem.isPublic == 1">公开</span>
          </div>
          <div class="intro overFlowHid">{{ activeItem.remark }}</div>
        </div>
        <div class="app-table">
          <el-table
            :header-cell-style="tableHeaderColor"
            ref="multipleTable"
            v-loading="listLoading"
            :data="tableData"
            style="width: 100%; margin-top: 15px"
          >
            <!-- <el-table-column type="selection" /> -->
            <el-table-column type="index" label="序号" width="100" />
            <el-table-column label="企业名称" property="entName" />
            <el-table-column label="社会统一信用代码" property="creditCode" />
            <!-- <el-table-column label="导入账号" property="updatedBy" />
                        <el-table-column label="导入时间" property="updatedTime" /> -->
            <el-table-column label="操作" width="80px">
              <template slot-scope="scope">
                <div>
                  <el-button
                    type="text"
                    style="color: red"
                    size="small"
                    @click="delEntDate(scope.row)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <div slot="empty" class="noData">
              <div class="noData-img"></div>
            </div>
          </el-table>
          <!--翻页工具条-->
          <div class="pagination-container">
            <el-pagination
              v-if="total"
              background
              @size-change="getPageSize"
              @current-change="getPageNum"
              :total="total"
              :current-page="condition.pageNum"
              :page-size="condition.pageSize"
              :page-sizes="[10, 20, 30, 40]"
              layout="total, sizes, prev, pager, next, jumper"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- 创建/编辑文件夹 -->
    <el-dialog
      :title="isAddFolder ? '创建文件夹' : '编辑文件夹'"
      :visible.sync="addFolderVisible"
      ref="addFolderForm"
      width="40%"
      :before-close="closeAddFolder"
    >
      <el-form label-width="170px">
        <el-form-item label="文件夹名称：">
          <el-input
            placeholder="请输入文件夹名称"
            v-model="addFolderForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业是否支持多个标签：">
          <el-select
            v-model="addFolderForm.isRepeat"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAddFolder">取 消</el-button>
        <el-button type="primary" @click="submitAddFolder()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除文件夹 -->
    <el-dialog
      title="删除文件夹"
      :visible.sync="delFolderVisible"
      width="40%"
      ref="delFolderForm"
      :before-close="closeDelFolder"
    >
      <el-form label-width="90px">
        <el-form-item label="删除方式：" prop="name">
          <el-select
            v-model="delFolderForm.type"
            placeholder="请选择删除方式"
            style="width: 100%"
          >
            <el-option label="仅删除文件夹" :value="1"></el-option>
            <el-option label="删除文件夹及其子标签" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDelFolder">取 消</el-button>
        <el-button type="primary" @click="submitdelFolder()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 创建、编辑标签 -->
    <el-dialog
      :title="isAdd ? '创建标签' : '编辑标签'"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="closeLabel"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="标签名称：" prop="name">
          <el-input
            placeholder="请输入标签名称"
            maxlength="20"
            show-word-limit
            v-model="ruleForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="具体描述：" prop="remark">
          <el-input
            type="textarea"
            maxlength="100"
            show-word-limit
            placeholder="请输入具体描述"
            v-model="ruleForm.remark"
            :rows="3"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否公开：" prop="isPublic">
                    <el-switch v-model="ruleForm.isPublic" :active-value="1" :inactive-value="2"></el-switch>
                </el-form-item>
                <el-form-item label="导入权限：" prop="depName">
                  <el-select clearable v-model="ruleForm.depName" placeholder="请选择可导入的部门">
                    <el-option v-for="(item, index) in departmentOptions" :key="index" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="时间维度：" prop="timeDimension">
                    <el-radio v-model="ruleForm.timeDimension" :label="1">有时间</el-radio>
                    <el-radio v-model="ruleForm.timeDimension" :label="2">没有时间</el-radio>
                </el-form-item>
                <el-form-item label="时间选择：" prop="dataYear" v-if="ruleForm.timeDimension==1">
                    <el-select v-model="ruleForm.dataYear" placeholder="请选择年份">
                        <el-option
                            :label="item"
                            :value="item"
                            v-for="(item,index) of yearOption"
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeLabel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 移动标签至某个文件夹 -->
    <el-dialog
      title="移动"
      ref="moveLabelForm"
      :visible.sync="moveLabelVisible"
      width="40%"
      :before-close="closeMoveLabel"
    >
      <el-form label-width="140px">
        <el-form-item label="文件夹：" prop="name">
          <el-cascader
            v-model="moveLabelForm.parentId"
            :options="folderList"
            :props="{
              checkStrictly: true,
              label: 'name',
              value: 'id',
              emitPath: false,
            }"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeMoveLabel">取 消</el-button>
        <el-button type="primary" @click="submitMoveLabel()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 精准添加 -->
    <el-dialog
      title="精准添加"
      :visible.sync="preciseAddVisible"
      width="500px"
      class="preciseAddDialog"
      :before-close="closeAddEnt"
    >
      <div style="min-height: 140px">
        <el-select
          v-model="preciseAddEntList"
          multiple
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          style="width: 80%"
        >
          <el-option
            v-for="item in entListOptions"
            :key="item.id"
            :label="item.entName"
            :value="item.entName"
          ></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAddEnt">取 消</el-button>
        <el-button type="primary" @click="submitPreciseEnt()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { notEmpty, noBlank } from '@/common/utils/validate'
import { setRem } from '@/common/utils/remUnit'
import {
  showDictLabel,
  getEntList,
  getEntData,
  deleteEntLableForAll,
  addDictLabel,
  updateDictLabel,
  deleteDictLabel,
  moveDictLabel,
  downloadModel,
  insertEnt,
  downloadEntLabel,
  deleteEntLable,
} from '@/common/api/entTag/entTag'
export default {
  name: 'TagList',
  props: {},
  data() {
    return {
      visible: false,
      listLoading: false,
      name: '', // 搜索标签名
      yearOption: [], // 年份下拉选
      // 左侧树状图
      activeItem: {},
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      condition: {
        name: '',
        yearType: null,
        dataYear: '',
        entName: '',
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      input2: '',
      tableData: [],
      // 新增编辑标签弹框
      isAdd: true,
      dialogVisible: false,
      ruleForm: {
        name: '',
        remark: '',
        isPublic: 1,
        timeDimension: 1,
        dataYear: '',
        depName: '',
      },
      rules: {
        name: [notEmpty('标签名称'), noBlank()],
        remark: [notEmpty('具体描述'), noBlank()],
      },
      // 创建文件夹弹框
      isAddFolder: false,
      folderId: '',
      addFolderVisible: false,
      addFolderForm: {},
      // 移动子文件夹弹框
      moveLabelVisible: false,
      moveLabelForm: {},
      folderList: [],
      // 删除子文件夹弹框
      delFolderVisible: false,
      delFolderForm: {},
      // 精准添加
      allEntList: [],
      preciseAddVisible: false,
      preciseAddEntList: [],
      // 模糊搜索框
      entListOptions: [],
      entListOptions1: [],
      loading: false,
      departmentOptions: [
        '国土局',
        '税务局',
        '电力局',
        '经信局',
        '科技局',
        '环保局',
      ],
      /**
       * isDirector  1 文件夹 2标签
       * type 1计算规则标签 2 原始标签 3复制标签
       */
    }
  },
  created() {
    // this.setRem()
    this.initYearList()
  },
  mounted() {
    // 获取标签数据
    this.getTreeData()
    this.getTreeData(1)
  },
  watch: {},
  methods: {
    // 全部-有年份-无年份 单选按钮改变
    radioGroupChange(val) {
      this.treeData = []
      if (val == 2 || val == null) {
        // 全部-无数据
        this.condition.dataYear = ''
      } else {
        this.condition.dataYear = new Date().getFullYear()
      }
      this.getTreeData(2, this.condition.yearType)
    },
    // 获取年份配置
    initYearList() {
      this.ruleForm.dataYear = new Date().getFullYear()
      for (let i = 2017; i < 2028; i++) {
        this.yearOption.push(i)
      }
    },
    // 获取标签数据
    getTreeData(isDirector = 2, timeDimension = null) {
      let params = { isDirector, timeDimension }
      if (this.name && isDirector === 2) {
        params.name = this.name
      }
      params.name = this.name
      params.dataYear = this.condition.dataYear
      showDictLabel(params).then((res) => {
        let resList = res.data.data
        if (isDirector === 2) {
          this.treeData = resList || []
          // 找到节点下的企业标签--找到返回的标签数据的第一个标签
          let activeItem = this.findActiveId(resList) || {}
          if (activeItem.id && this.activeItem.id !== activeItem.id) {
            this.activeItem = { ...activeItem }
            // 获取标签的企业数据
            this.getEntData()
            // 获取标签当前年的所有精准添加企业
            // this.getAllEntList()
          }
        } else {
          this.treeData = resList || []
          let data = resList || []
          // 将无值的child全部置为null
          data = this.handleChild(data)
          this.folderList = [
            { id: '根', name: '全部标签', children: [...data] },
          ]
        }
      })
    },
    // 找到节点下的企业标签--找到返回的标签数据的第一个标签
    findActiveId(arr) {
      let activeItem = {}
      if (arr && arr.length > 0) {
        for (let index = 0; index < arr.length; index++) {
          const item = arr[index]
          if (item.isDirector != 1) {
            // 标签
            activeItem = { ...item }
            break
          } else if (item.children && item.children.length > 0) {
            // 文件夹
            let childItem = this.findActiveId(item.children)
            if (childItem && childItem.id) {
              activeItem = { ...childItem }
              break
            }
          }
        }
        if (activeItem && activeItem.id) {
          return activeItem
        }
      } else {
        return false
      }
    },
    // 将无值的child全部置为null
    handleChild(arr) {
      arr = arr || []
      let handledArr = arr.map((item) => {
        if (!item.children || item.children.length === 0) {
          item.children = null
        } else {
          let childArr = this.handleChild(item.children)
          item.children = childArr
        }
        return item
      })
      return handledArr
    },
    // 获取标签对应的企业数据
    getEntData(pageNum = 1) {
      this.condition.pageNum = pageNum
      let params = { ...this.condition }
      params.name = this.activeItem.name
      params.code = this.activeItem.id
      getEntList(params).then((respone) => {
        let res = respone.data.data
        this.tableData = res.results || []
        this.total = res.totalRecord
      })
    },
    // 获取标签当前年的所有精准添加企业
    // getAllEntList() {
    //   let params = {
    //     name: this.activeItem.name,
    //     code: this.activeItem.id,
    //     type: 2
    //   }
    //   if (this.activeItem.dataYear) {
    //     params.dataYear = this.activeItem.dataYear
    //   }
    //   getEntData(params).then(res => {
    //     this.allEntList = res || []
    //     this.entListOptions = res || []
    //   })
    // },
    // 操作数-点击标签
    getLabelEnt(data) {
      if (data.isDirector == 1) {
        // 文件夹
        // 找到节点下的企业标签--找到返回的标签数据的第一个标签
        let activeItem = this.findActiveId([data])
        if (
          activeItem &&
          activeItem.id &&
          this.activeItem.id !== activeItem.id
        ) {
          this.activeItem = { ...activeItem }
          // 获取标签的企业数据
          this.getEntData()
          // 获取标签当前年的所有精准添加企业
          // this.getAllEntList()
        }
      } else if (this.activeItem.id !== data.id) {
        this.activeItem = { ...data }
        // 获取标签的企业数据
        this.getEntData()
        // 获取标签当前年的所有精准添加企业
        // this.getAllEntList()
      }
    },
    // 新增/编辑文件夹-弹框
    editFolderName(data) {
      if (data.id) {
        // 编辑文件夹
        let { id, name, parentId, isRepeat } = data
        this.addFolderForm = { id, parentId }
        if (!this.isAddFolder) {
          this.addFolderForm = { name, isRepeat, ...this.addFolderForm }
        }
      }
      this.addFolderVisible = true
    },
    // 新增编辑文件夹-关闭弹框
    closeAddFolder() {
      this.addFolderVisible = false
      for (let item in this.addFolderForm) {
        this.addFolderForm[item] = null
      }
    },
    // 新增编辑文件夹-提交
    submitAddFolder() {
      if (!this.addFolderForm.name) {
        this.$message.warning('请输入文件夹名称')
        return false
      } else if (!this.addFolderForm.isRepeat) {
        this.$message.warning('请选择是否支持多个标签')
        return false
      } else {
        let params = {
          name: this.addFolderForm.name,
          isDirector: 1,
          // 1-可多个 2-不可以多个
          isRepeat: this.addFolderForm.isRepeat,
        }
        if (this.isAddFolder) {
          // 新增
          params.parentId = this.addFolderForm.id
        } else {
          // 编辑
          params.id = this.addFolderForm.id
          params.parentId = this.addFolderForm.parentId
        }
        let api
        api = this.isAddFolder ? addDictLabel : updateDictLabel
        api(params).then((res) => {
          this.closeAddFolder()
          this.getTreeData(1)
          this.getTreeData()
          this.$message.success('保存成功')
        })
      }
    },
    // 删除文件夹-弹框
    delFolder(row) {
      if (row.id) {
        this.delFolderForm.id = row.id
        this.delFolderVisible = true
      }
    },
    // 删除文件-关闭弹框
    closeDelFolder() {
      this.delFolderVisible = false
      for (let item in this.delFolderForm) {
        this.delFolderForm[item] = null
      }
    },
    // 删除文件夹-提交
    submitdelFolder() {
      if (!this.delFolderForm.type) {
        this.$message.warning('请选择删除方式')
        return false
      } else {
        deleteDictLabel(this.delFolderForm).then((res) => {
          this.$message.success('删除成功')
          this.getTreeData(1)
          this.getTreeData()
          this.closeDelFolder()
        })
      }
    },
    // 新增编辑标签-打开弹框
    editData(row) {
      if (row.id) {
        let { id, name, remark, parentId, isPublic, timeDimension, depName } =
          row
        this.ruleForm = { id, parentId }
        if (!this.isAdd) {
          this.ruleForm = {
            ...this.ruleForm,
            name,
            remark,
            isPublic,
            timeDimension,
            depName,
          }
        } else {
          this.ruleForm = {
            ...this.ruleForm,
            isPublic: 1,
            timeDimension: 1,
          }
        }
      } else {
        this.ruleForm = {
          isPublic: 1,
          timeDimension: 1,
        }
      }
      this.dialogVisible = true
    },
    // 新增编辑标签-关闭弹框
    closeLabel() {
      this.dialogVisible = false
      for (let item in this.ruleForm) {
        this.ruleForm[item] = null
      }
    },
    // 提交标签
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            name: this.ruleForm.name,
            remark: this.ruleForm.remark,
            isDirector: 2,
            isPublic: this.ruleForm.isPublic,
            dataYear: this.ruleForm.dataYear,
            timeDimension: this.ruleForm.timeDimension,
            depName: this.ruleForm.depName,
          }
          // 新增
          if (this.isAdd) {
            params.parentId = this.ruleForm.id
          } else {
            params.id = this.ruleForm.id
            params.parentId = this.ruleForm.parentId
          }
          if (params.timeDimension === 2) {
            delete params.dataYear
          }
          let api
          api = this.isAdd ? addDictLabel : updateDictLabel
          api(params).then((res) => {
            this.getTreeData()
            this.closeLabel()
            this.$message.success('保存成功')
          })
        }
      })
    },
    // 删除标签
    delLabel(row) {
      this.$confirm('是否确认删除该标签?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteDictLabel({ id: row.id }).then((res) => {
            this.$message.success('删除成功')
            this.getTreeData()
          })
        })
        .catch(() => {})
    },
    // 移动子标签-打开弹框
    moveLabel(row) {
      this.moveLabelForm.id = row.id
      this.moveLabelVisible = true
    },
    // 移动子标签-关闭弹框
    closeMoveLabel() {
      this.moveLabelVisible = false
      for (let item in this.moveLabelForm) {
        this.moveLabelForm[item] = null
      }
    },
    // 移动子标签-提交
    submitMoveLabel() {
      if (!this.moveLabelForm.parentId) {
        this.$message.warning('请选择文件夹')
      } else {
        let params = { ...this.moveLabelForm }
        if (params.parentId === '根') {
          params.parentId = null
        }
        moveDictLabel(params).then((res) => {
          this.$message.success('移动成功')
          this.closeMoveLabel()
          this.getTreeData()
          this.getTreeData(1)
        })
      }
    },
    // 模板下载
    downLoadModel() {
      downloadModel({ dataYear: 2019 })
    },
    // 精准添加-搜索
    remoteMethod(query) {
      // this.preciseAddEntList=[]
      this.loading = true
      if (query) {
        // let params = {
        //   key: query,
        //   name: this.activeItem.name,
        //   code: this.activeItem.id,
        //   type: 2,
        // };
        let params = {
          entName: query,
          size: 10,
        }
        if (this.activeItem.dataYear) {
          params.dataYear = this.activeItem.dataYear
        }
        getEntData(params).then((res) => {
          let resList = res.data.data
          this.loading = false
          this.entListOptions = resList || []
          this.entListOptions1.push(...resList)
        })
      } else {
        this.loading = false
        // this.entListOptions = this.allEntList
      }
    },
    // 精准添加-提交
    submitPreciseEnt() {
      const res = new Map()
      this.entListOptions1 = this.entListOptions1.filter(
        (arr) => !res.has(arr.creditCode) && res.set(arr.creditCode, 1)
      )
      if (this.preciseAddEntList.length === 0) {
        this.$message.warning('请至少选择一个企业')
        return false
      }
      let nameList = []
      let creditCodeList = []
      this.entListOptions1.forEach((item) => {
        if (this.preciseAddEntList.indexOf(item.entName) !== -1) {
          nameList.push(item.entName)
          creditCodeList.push(item.creditCode)
        }
      })
      let params = {
        type: 2,
        name: this.activeItem.name,
        entName: nameList.join(','),
        creditCode: creditCodeList.join(','),
        code: this.activeItem.id,
      }
      if (this.activeItem.dataYear) {
        params.dataYear = this.activeItem.dataYear
      }
      insertEnt(params).then((response) => {
        let res = response.data.data
        console.log(response.data)
        if (response.data.code === '0000') {
          if (res && res.indexOf('仅支持单个标签') > -1) {
            this.$message.error(response.data.msg)
          } else {
            this.$message.success('添加成功')
          }
        } else {
          this.$message.error(response.data.msg)
        }
        this.closeAddEnt()
        this.getEntData()
      })
    },
    closeAddEnt() {
      this.preciseAddVisible = false
      this.preciseAddEntList = []
      this.entListOptions1 = []
      this.entListOptions = []
    },
    // 数据导出
    downLoad() {
      if (!this.activeItem.name) {
        this.$message.warning('选中目录下无有效标签')
        return false
      }
      downloadEntLabel({
        name: this.activeItem.name,
        code: this.activeItem.id,
      })
    },
    // 表格操作-删除企业
    delEntDate(row) {
      this.$confirm('是否确认删除该企业?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteEntLable({ id: row.id }).then((res) => {
            this.$message.success('删除成功')
            this.getEntData()
          })
        })
        .catch(() => {})
    },
    // 清空当前标签下的所有企业
    clearAllEnt() {
      if (!this.activeItem.name) {
        this.$message.warning('选中目录下无有效标签')
        return false
      }
      this.$confirm('是否确定清除该标签下的所有企业名单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteEntLableForAll({ code: this.activeItem.id }).then((res) => {
            this.$message.success('清空成功')
            this.getEntData()
          })
        })
        .catch(() => {})
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #FAFAFA;color: rgba(0,0,0,.85);font-weight: 550;'
      }
    },
    // 分页
    getPageSize(val) {
      this.condition.pageSize = val
      this.getEntData()
    },
    getPageNum(val) {
      this.condition.pageNum = val
      this.getEntData(val)
    },
    // 表格序号
    initIndex(index) {
      return index + 1
    },
  },
  components: {},
}
</script>

<style lang="scss" scoped>
@import '~@/common/styles/variables.scss';
@import '~@/common/styles/index.scss';
@import '~@/common/styles/mjCommon.scss';

$width: 262px;
.page-notbreadcrumb {
  display: flex;
  width: 100%;
  height: 100%;
  .page-list {
    width: 310px !important;
  }
  .page-prop {
    width: calc(100% - 310px);
  }
  .detail {
    height: calc(100% - 60px);
    padding: 15px 20px;
    .condition_box {
      display: flex;
      justify-content: space-between;
    }
  }
  & >>> .tag-tree {
    .is-current > .el-tree-node__content {
      background: #e0e7ff;
      .title {
        color: #4d76fd;
      }
    }
    .el-tree-node__content {
      width: 100%;
      height: 40px;
      padding-right: 3px;
      font-size: 14px;
      box-sizing: border-box;
      display: flex;
      .node-item {
        flex: 1;
        width: 0;
        // width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .subtitle {
          display: flex;
          align-items: center;
          // flex: 1;
          height: 40px;
          width: 80%;
          i {
            font-size: 14px;
            margin-right: 8px;
          }
          span {
            display: inline-block;
            width: 100%;
          }
        }
        .more {
          flex-shrink: 0;
          padding: 5px;
          .el-icon-more {
            padding: 5px 0;
          }
        }
      }
    }
  }
  & >>> .el-dialog {
    .el-dialog__header {
      padding-bottom: 20px !important;
      border-bottom: 1px solid #ebebeb;
      .header {
        display: flex;
        align-items: center;
        font-weight: 550;
      }
      .iconshuxing {
        font-size: 23px;
        color: #0091ff;
        margin-right: 5px;
      }
    }
    .el-dialog__body {
      min-height: 300px;
      padding: 40px 60px;
      box-sizing: border-box;
    }
    .el-dialog__footer {
      padding-top: 20px !important;
      border-top: 1px solid #ebebeb;
    }
  }
  & >>> .el-drawer__body {
    height: calc(100%);
  }
}

.app-table {
  height: calc(100% - 110px);
  @include bottomCom;
  & >>> .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background-color: white;
      border-radius: 2em;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(147, 153, 165, 0.4);
      border-radius: 2em;
    }
  }
}
/deep/.el-radio-group {
  width: 100%;
  margin: 15px 0;
  .el-radio-button {
    width: 33.3%;
    .el-radio-button__inner {
      width: 100%;
    }
  }
}
.label-banner {
  height: 74px;
  border: 1px solid #ebeef5;
  padding: 0 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .label {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    span {
      padding: 2px 6px;
      font-size: 12px;
      color: #4d76fd;
      border: 1px solid #b3c2f6;
      background: #eaefff;
      border-radius: 4px;
      margin-left: 6px;
    }
  }
  .intro {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
  }
  .overFlowHid {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
